import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.668 6.442a.7.7 0 0 0-.993-.988l-1.222 1.23-.557-.56a.7.7 0 0 0-.993.987l1.054 1.058a.7.7 0 0 0 .992 0zM10 6.24a.7.7 0 1 0 0 1.4h9.6a.7.7 0 1 0 0-1.4zm0 5.067a.7.7 0 1 0 0 1.4h9.6a.7.7 0 1 0 0-1.4zm0 5.068a.7.7 0 1 0 0 1.4h9.6a.7.7 0 1 0 0-1.4zm-2.332-4.73a.7.7 0 1 0-.993-.986l-1.222 1.228-.557-.56a.7.7 0 1 0-.993.988l1.054 1.059a.7.7 0 0 0 .992 0zm-.003 4.183a.7.7 0 0 1 .003.99l-1.719 1.728a.7.7 0 0 1-.992 0l-1.054-1.06a.7.7 0 1 1 .993-.987l.557.56 1.222-1.228a.7.7 0 0 1 .99-.003",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ChecklistIcon24.js.map